import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import IconButton from "@khanacademy/wonder-blocks-icon-button";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

import {ImagePreview} from "../image-attach/image-preview.tsx";

import xCircleIcon from "@phosphor-icons/core/fill/x-circle-fill.svg";

export interface ImageProps {
    image: string;
    altText?: string;
    onDelete?: () => void;
}

export const ChatBoxImageAttachment = React.memo(
    ({image, altText, onDelete}: ImageProps): React.ReactElement => (
        <View style={styles.container}>
            <ImagePreview
                displayWidth={64}
                displayHeight={64}
                image={image}
                altText={altText}
            />
            <IconButton
                onClick={onDelete}
                disabled={false}
                icon={xCircleIcon}
                kind="tertiary"
                actionType="neutral"
                size="small"
                style={styles.detachButton}
                aria-label={t`Delete image`}
            />
        </View>
    ),
);

const styles = StyleSheet.create({
    container: {
        margin: spacing.xSmall_8,
        marginBlockEnd: 0,
        width: 80,
    },
    detachButton: {
        position: "absolute",
        top: -4,
        insetInlineEnd: 8,
        // The styling below ensures the "X" is opaque, and doesn't let the
        // image color bleed through.
        backgroundColor: color.offWhite,
        width: spacing.medium_16,
        height: spacing.medium_16,
        borderRadius: "50%",
    },
});
